module.exports = __webpack_public_path__ + "img/ic_close.c912c621.svg";